import React, { Children, createRef } from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import MobileMenuCard from './components/mobile_menu_card/MobileMenuCard';

import './MobileMenu.scss';

/**
 * @deprecated
 */
export default class MobileMenu extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeCard: 0,
      open: false,
      activeTransitioning: false
    };

    Children.forEach(props.children, (child, index) => {
      this[`card${index}Ref`] = createRef();
    });
  }

  onOutsideClick = event => {
    if (
      typeof event.target.className !== 'undefined' &&
      !event.target.className.includes('mobile-menu') &&
      !event.target.className.includes('leaf-trigger')
    ) {
      this.setState({ open: false });
    }
  };

  onTriggerClick = index => {
    const { open, activeCard } = this.state;
    const stateUpdate = { activeCard: index };

    if (!open) {
      stateUpdate.open = true;
    } else {
      stateUpdate.activeTransitioning = true;

      if (activeCard === index) {
        stateUpdate.open = false;
      }
    }

    this.setState(stateUpdate, () => {
      const { activeTransitioning } = this.state;

      if (activeTransitioning) {
        setTimeout(() => this.setState({ activeTransitioning: false }), 200);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { open } = this.state;

    if (open !== prevState.open && typeof document !== 'undefined') {
      if (open) {
        document.addEventListener('click', this.onOutsideClick);
      } else {
        document.removeEventListener('click', this.onOutsideClick);
      }
    }
  }

  render() {
    const { activeCard, open, activeTransitioning } = this.state;
    const { children } = this.props;
    const cards = [];

    Children.forEach(children, (card, index) => {
      const active = open && index === activeCard;
      const { color, icon } = card.props;
      const bottom = `${16 + index * 50}px`;
      const iconDisplayed = active ? 'times' : icon;
      const className = ClassNames([
        active && activeTransitioning && 'active-transition'
      ]);

      cards.push(
        <MobileMenuCard
          active={active}
          className={className}
          color={color}
          icon={iconDisplayed}
          key={icon}
          onTriggerClick={() => this.onTriggerClick(index)}
          ref={this[`card${index}Ref`]}
          triggerStyle={{ bottom }}
        >
          {card}
        </MobileMenuCard>
      );
    });

    const containerClasses = ClassNames(['mobile-menu', open && 'open']);

    return <div className={containerClasses}>{cards}</div>;
  }
}

MobileMenu.propTypes = {
  children: oneOfType([node, arrayOf(node)])
};

MobileMenu.defaultProps = {
  children: undefined
};
